/**
 * ============================================================================
 * BAMBOOVE — CHIA MÔ TẢ SẢN PHẨM VÀO ĐÚNG MỤC ACCORDION (trang sản phẩm)
 * phiên 77 · 17/10/2026 — cập nhật theo duyệt của chủ dự án
 * ----------------------------------------------------------------------------
 * THAY ĐỔI Ở PHIÊN 77 (so với 76h):
 *   - Bảng QUY_TAC đoán từ khoá → luật CỤ THỂ theo TIÊU ĐỀ
 *     (Details / Care / Shipping and guarantee → mục đích tương ứng).
 *   - Thêm bước CÁ NHÂN HOÁ: tách dòng "Fabric: X% bamboo fibre, …" từ P3
 *     → chèn thành 1 dòng "Sản phẩm này: X% bamboo fibre" vào đầu Mục 2.
 *   - Nếu mục đích ĐÃ CÓ nội dung theme → chỉ GỠ khỏi Mục 1.
 *   - Nếu mục đích TRỐNG → CHUYỂN nội dung sang đó (bỏ tiêu đề gốc).
 * VẪN GIỮ: KHÔNG đụng nội dung sản phẩm trong Shopify — chỉ DOM lúc chạy.
 * ============================================================================
 */
(function () {
  'use strict';

  var QUY_TAC = [
    { dich: 'fabric', tieuDe: ['details', 'fabric and care', 'fabric'] },
    { dich: 'fabric', tieuDe: ['care'] },
    { dich: 'ship',   tieuDe: ['shipping and guarantee', 'shipping and returns', 'shipping'] },
  ];

  var DOAN_MANH_QUY_TAC = [
    { dich: 'ship', khoa: 'shipping and guarantee' },
    { dich: 'ship', khoa: 'shipping' },
  ];

  /* ===== PHIÊN 78 — LÀM GỌN MỤC 1 (ĐANG THỬ Ở 1 SẢN PHẨM) ==================
   * Chủ dự án chốt 17/10/2026: tỷ lệ bamboo TỐI ĐA của cả dòng là 70% (KHÔNG phải 75%).
   * Mục 1 hiện có 2 lớp chữ: lớp theme (4 gạch) + mô tả Shopify (4 gạch)
   * ⇒ 2 gạch BỊ LẶP Ý: "graduated compression" và "bamboo blend … %".
   * Luật: ① bỏ đúng 2 gạch lặp khỏi mô tả sản phẩm ② đổi mọi "75%" → "70%".
   * ⚠️ AP_DUNG_TAT_CA = false ⇒ CHỈ áp cho DS_THU (để chủ dự án duyệt 1 sản phẩm trước).
   *    Duyệt xong ⇒ đặt AP_DUNG_TAT_CA = true (áp cho cả 13 sản phẩm).
   * ========================================================================== */
  var AP_DUNG_TAT_CA = true;
  var DS_THU = ['bamboove-classic-bamboo-compression-socks-onyx-black'];

  function dangApDung() {
    if (AP_DUNG_TAT_CA) return true;
    var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
    return !!(m && DS_THU.indexOf(m[1]) >= 0);
  }

  /* ===== PHIÊN 78b — PDP MẪU ONYX (chủ dự án chốt 17/10/2026) =================
   * ① KHUNG 3 DÒNG CAM KẾT: bỏ DÒNG PHỤ (chỉ in đậm 1 ý) — ảnh mẫu do chủ dự án gửi.
   * ② MỤC 1: chỉ nói về sản phẩm ĐANG Ở PDP, KHÔNG thêm so sánh dòng khác.
   *    → 1 đoạn mô tả ngắn (màu + tỷ lệ + mức ép) + 2 gạch "Why…" RIÊNG.
   * ③ MỤC 2: bảng 3 dòng tỷ lệ (Classic 45 / Essential 36 / Crew 70) + highlight dòng 45
   *    + 1 dòng "More bamboo = softer…" + 1 dòng ngắn + link tới /pages/wash-care
   *    (bỏ 5 ý giặt dài — chuyển sang trang riêng).
   * ④ MỤC 3: BỎ hoàn toàn (chỉ áp cho sản phẩm đang thử).
   * ⑤ MỤC 4: giữ 2 khối ship + returns + thêm 2 link "View full …" + sửa $8 → $7.95.
   * ========================================================================== */

  /* Thay dòng mô tả về bamboo blend trong mô tả SP bằng câu theo DÒNG SP đang xem.
   * Lấy tỷ lệ thật từ <li>Fabric: … trong P3 (đã có ở 78). Tránh nói về dòng khác.
   * Giữ nguyên 2 gạch "Why…" RIÊNG (sized by calf, built to survive the wash). */
  var ICON = {
    gauge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17a9 9 0 1 1 18 0"/><path d="M12 17l4-5"/><circle cx="12" cy="17" r="1.4"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 4 13c0-5 4-9 16-9 0 12-4 16-9 16Z"/><path d="M4 20c4-8 9-11 13-12"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5S5.5 10 5.5 14.5a6.5 6.5 0 0 0 13 0C18.5 10 12 3.5 12 3.5Z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6l7-3Z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg>'
  };

  /* 78e: GỘP "Why…" + 4 khối icon thành 1 danh sách 5 lợi ích NGẮN, có icon.
   * Chỉ giữ lợi ích CỐT LÕI; bỏ câu dài và các ý phụ (nurses/travel/everyday đã nằm ở đoạn giới thiệu). */
  function dungDanhSachLoiIch(goc, tl, mucEp) {
    var dong = tl === 70 ? 'crew' : tl === 36 ? 'essential' : 'classic';
    /* Cá nhân hoá theo DÒNG: Crew là one-size (không đo bắp chân), chất vải khác */
    var dong2 = dong === 'crew'
      ? ['One size fits most', 'AU women\u2019s 5\u201311, men\u2019s 4\u201310.']
      : ['Sized by your calf', 'A fit that suits almost everyone.'];
    var phu3 = dong === 'crew'
      ? 'Our highest bamboo blend.'
      : dong === 'essential'
      ? 'Blended with nylon for a firmer, more structured feel.'
      : 'Soft and smooth on the skin.';
    var ds = [
      [ICON.gauge, 'Graduated ' + mucEp, 'Gentle support from ankle to calf.'],
      [ICON.ruler, dong2[0], dong2[1]],
      [ICON.leaf, tl + '% bamboo', phu3],
      [ICON.drop, 'Breathable all day', 'Fresh feet from morning to night.'],
      [ICON.shield, 'Made to last', 'Cuff and compression keep their shape, wash after wash.']
    ];
    var head = document.createElement('p');
    head.className = 'bb-benefit__head';
    /* 79 (19/10/2026): store CHƯA có review nào ⇒ không được nói "why people keep buying them".
     * Chủ dự án chốt đổi thành "What you get". */
    head.textContent = 'What you get';
    var ul = document.createElement('ul');
    ul.className = 'bb-benefit';
    ds.forEach(function (x) {
      var li = document.createElement('li');
      li.innerHTML = '<span class="bb-benefit__ico" aria-hidden="true">' + x[0] + '</span>' +
        '<span class="bb-benefit__txt"><strong>' + x[1] + '.</strong> ' + x[2] + '</span>';
      ul.appendChild(li);
    });
    goc.appendChild(head);
    goc.appendChild(ul);
    return ds.length;
  }

  /* ===== 79 (19/10/2026) — MỤC 2: VẢI CỦA ĐÚNG ĐÔI ĐANG XEM ================
   * Chủ dự án chốt: bỏ bảng 3 dòng (bày sản phẩm KHÁC ngay trên PDP) và câu
   * chung chung "More bamboo feels softer…". Mỗi đôi chỉ nói về tỷ lệ của
   * CHÍNH NÓ, và mỗi thành phần phải quy ra LỢI ÍCH khách nhận được.
   * Nguồn: dòng "Fabric: …" trong mô tả Shopify — KHÔNG bịa số.
   * ======================================================================== */
  var VAI_THEO_DONG = {
    45: {
      ten: 'Classic',
      y: [
        ['45% bamboo', 'Soft on the skin and breathable through a long shift, so your feet feel fresh at the end of the day.'],
        ['45% polyester', 'Gives the knit its structure and helps it dry fast, so the pair keeps its shape wash after wash.'],
        ['10% spandex', 'The stretch that lets the cuff sit flat on your calf without digging in.']
      ]
    },
    36: {
      ten: 'Essential',
      y: [
        ['36% bamboo', 'Soft enough to feel gentle, with a firmer knit around the foot.'],
        ['55% nylon', 'Why this pair holds more firmly than the Classic: a steadier, more structured support.'],
        ['9% spandex', 'Keeps the pressure even from ankle to calf, and the shape between washes.']
      ]
    },
    70: {
      ten: 'Crew',
      y: [
        ['70% bamboo', 'Our highest bamboo share: the softest, most breathable pair we make, for warm feet and long days.'],
        ['25% polyester', 'Just enough structure to hold its shape and dry quickly after a wash.'],
        ['5% spandex', 'A light stretch that hugs the foot without pressing on it.']
      ]
    }
  };

  function tenMau() {
    var h1 = document.querySelector('h1');
    var t = h1 ? (h1.textContent || '') : '';
    var i = t.lastIndexOf(' - ');
    return i < 0 ? '' : t.slice(i + 3).trim();
  }

  function chuanHoaVai(chuoi) {
    if (!chuoi) return '';
    return chuoi.split(/[,·]/).map(function (x) {
      return x.replace(/fibre/gi, '').replace(/\s+/g, ' ').trim();
    }).filter(function (x) { return !!x; }).join(' · ');
  }

  function taoDongVai(ico, dam, phu) {
    var li = document.createElement('li');
    li.innerHTML = '<span class="bb-benefit__ico" aria-hidden="true">' + ico + '</span>' +
      '<span class="bb-benefit__txt"><strong>' + dam + '.</strong> ' + phu + '</span>';
    return li;
  }

  function dungKhoiVai(phanTram, chuoiVai) {
    var fabric = document.querySelector('[data-bb-acc-than="fabric"]');
    var dong = VAI_THEO_DONG[phanTram];
    if (!fabric || !dong) return null;

    /* ① gỡ bảng 3 dòng + tiêu đề cũ + câu so sánh chung (chỉ làm khi đã có dữ liệu) */
    var bo = 0;
    [].slice.call(fabric.querySelectorAll('h1,h2,h3,h4,h5,h6')).forEach(function (h) {
      if (/what is in your pair/i.test(chuanHoa(h.textContent))) {
        if (h.parentNode) { h.parentNode.removeChild(h); bo++; }
      }
    });
    [].slice.call(fabric.querySelectorAll('.bb-tbl')).forEach(function (t) {
      if (t.parentNode) { t.parentNode.removeChild(t); bo++; }
    });
    [].slice.call(fabric.querySelectorAll('p')).forEach(function (p) {
      if (/^more bamboo feels/i.test(chuanHoa(p.textContent))) {
        if (p.parentNode) { p.parentNode.removeChild(p); bo++; }
      }
    });
    [].slice.call(fabric.querySelectorAll('.bb-blk')).forEach(function (b) {
      if (!b.children.length && !(b.textContent || '').trim()) b.parentNode.removeChild(b);
    });

    /* ② dựng khối mới */
    var khoi = document.createElement('div');
    khoi.className = 'bb-blk bb-fab';

    var h = document.createElement('h3');
    h.className = 'bb-benefit__head';
    var mau = tenMau();
    h.textContent = 'The ' + (mau ? mau + ' ' : '') + dong.ten + ', fibre by fibre';

    var mixChu = chuanHoaVai(chuoiVai) || (phanTram + '% bamboo');
    var phan = mixChu.split(' · ');
    var mix = document.createElement('p');
    mix.className = 'bb-fab__mix';
    mix.innerHTML = '<strong>' + phan[0] + '</strong>' +
      (phan.length > 1 ? ' · ' + phan.slice(1).join(' · ') : '');

    var ul = document.createElement('ul');
    ul.className = 'bb-benefit bb-fab__list';
    var DS_ICO = [ICON.leaf, ICON.shield, ICON.gauge];
    dong.y.forEach(function (x, i) {
      ul.appendChild(taoDongVai(DS_ICO[i] || ICON.leaf, x[0], x[1]));
    });

    khoi.appendChild(h);
    khoi.appendChild(mix);
    khoi.appendChild(ul);

    /* ③ chèn NGAY TRƯỚC khối "Machine wash…" (giữ care ở cuối) */
    var careBlk = null;
    [].slice.call(fabric.querySelectorAll('p')).forEach(function (p) {
      if (/machine wash/i.test(p.textContent)) careBlk = p.parentNode;
    });
    if (careBlk && careBlk.parentNode === fabric) fabric.insertBefore(khoi, careBlk);
    else fabric.appendChild(khoi);

    return { dong: dong.ten, tiLe: phanTram, bo: bo, mix: mixChu };
  }

  function vietMoTaTheoSp(goc, tyLeBietTruoc) {
    var tl = tyLeBietTruoc || null; /* tỷ lệ bamboo — lấy từ tachTiLe() ở luồng chính */
    var soBoLap = 0;
    var dsUlSauKhiBo = []; /* các <ul> "Why…" còn lại sau khi bỏ gạch lặp */
    [].slice.call(goc.querySelectorAll('h1,h2,h3,h4,h5,h6')).forEach(function (h) {
      var ten = chuanHoa(h.textContent);
      if (/why people keep buying them/.test(ten)) {
        var n = h.nextElementSibling;
        while (n && n.tagName !== 'UL') n = n.nextElementSibling;
        if (n && n.tagName === 'UL') {
          [].slice.call(n.children).filter(function (li) { return li.tagName === 'LI'; }).forEach(function (li) {
            var strong = li.querySelector('strong');
            var liTen = chuanHoa(strong ? strong.textContent : li.textContent);
            var lapCompression = /compression/.test(liTen);
            var lapBamboo = /bamboo/.test(liTen) && /%/.test(liTen);
            if (lapCompression || lapBamboo) {
              li.parentNode.removeChild(li);
              soBoLap++;
            }
          });
          if (n.querySelectorAll('li').length === 0) {
            n.parentNode.removeChild(n);
            h.parentNode.removeChild(h);
          } else {
            dsUlSauKhiBo.push(n);
          }
        } else {
          h.parentNode.removeChild(h);
        }
      }
    });
    if (!tl) return { tyLe: null, soBoLap: soBoLap };

    /* 2) Đổi "75%" → "70%" (chủ dự án chốt — đã có ở 78) */
    doiTiLeSai(goc);

    /* 3) Chỉ cần MỨC ÉP cho danh sách lợi ích.
     * 79 (19/10/2026): BỎ đoạn chèn thêm "The balanced all-rounder…" / "Sits below the calf…"
     * — trùng ý với đoạn mở đầu + 5 gạch (chủ dự án chốt Mục 1 phải gọn). */
    var mucEp = tl === 70 ? '8–15 mmHg' : '15–20 mmHg';

    /* 78e: BỐ CỤC — ① đoạn giới thiệu → ② 5 lợi ích ngắn có icon (gộp "Why…" + 4 card) */
    /* a) Bỏ đoạn 2 của mô tả nếu TRÙNG ý "breathable" + "wash/repeat" */
    var dsP = [].slice.call(goc.querySelectorAll('p')).filter(function (el) {
      return !el.hasAttribute('data-bb-mota-sp');
    });
    var daBoP = 0;
    /* 79b (19/10/2026) — TEMPLATE: Mục 1 CHỈ giữ ĐOẠN MỞ ĐẦU.
     * 7/13 trang trước đây còn đoạn thứ 2 (nói thêm audience/ý đã có trong 5 gạch)
     * ⇒ chủ dự án chốt: mỗi PDP = 1 đoạn + "What you get" + 5 gạch, giống nhau toàn bộ. */
    for (var ip = 1; ip < dsP.length; ip++) {
      dsP[ip].parentNode.removeChild(dsP[ip]);
      daBoP++;
    }
    /* b) 79: KHÔNG chèn thêm đoạn nào sau đoạn giới thiệu (xem mục 3 phía trên). */
    /* c) Bỏ tiêu đề to "Why people keep buying them" + 2 gạch cũ + 4 khối icon cũ */
    var acc = goc.parentNode;
    var feat = acc ? acc.querySelector('.bb-feat-list') : null;
    if (feat) feat.parentNode.removeChild(feat);
    [].slice.call(goc.querySelectorAll('h1,h2,h3,h4,h5,h6')).forEach(function (h) {
      if (/why people keep buying them/i.test(chuanHoa(h.textContent))) h.parentNode.removeChild(h);
    });
    [].slice.call(goc.querySelectorAll('ul')).forEach(function (ul) {
      if (ul.className.indexOf('bb-benefit') < 0) ul.parentNode.removeChild(ul);
    });
    /* d) Dựng danh sách 5 lợi ích ngắn, có icon */
    var soLoiIch = dungDanhSachLoiIch(goc, tl, mucEp);
    return { tyLe: tl, soBoLap: soBoLap, boDoan: daBoP, loiIch: soLoiIch };
  }

  /* 78b: MUC 2 — thay khoi "Washing, how to keep the compression" (5 <li>) bang 1 dong + link.
   * Lam viẹc nay o muc 2 ([data-bb-acc-than="fabric"]) cua sản phẩm đang thử. */
  function rutGonCareMuc2() {
    var fabric = document.querySelector('[data-bb-acc-than="fabric"]');
    if (!fabric) return false;
    var ds = [].slice.call(fabric.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var thay = false;
    ds.forEach(function (h) {
      if (thay) return;
      if (/^washing,\s*how to keep the compression$/i.test(chuanHoa(h.textContent))) {
        var n = h.nextElementSibling;
        while (n && n.tagName !== 'UL' && n.tagName !== 'P') n = n.nextElementSibling;
        if (n && n.tagName === 'UL') {
          var p = document.createElement('p');
          p.className = 'bb-feat__d';
          p.setAttribute('data-bb-care-rut-gon', '1');
          p.innerHTML = 'Machine wash on a gentle cycle, or hand wash in cold water (below 30°C). ' +
            '<a href="/pages/wash-care">See the full Wash &amp; Care routine →</a>';
          n.parentNode.replaceChild(p, n);
          thay = true;
        }
      }
    });
    return thay;
  }

  /* 78b: MUC 4 — them 2 link "View full ..." o cuoi 2 <ul> cua Mục 4.
   * Tìm theo tieu de (Shipping Australia / [days]-day money-back) chứ không phải vị trí DOM. */
  function themLinkPolicyMuc4() {
    var ship = document.querySelector('[data-bb-acc-than="ship"]');
    if (!ship) return 0;
    var ds = [].slice.call(ship.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var daThem = 0;
    ds.forEach(function (h) {
      var ten = chuanHoa(h.textContent);
      var link = null;
      if (/^shipping\s*\(australia\)$/.test(ten)) {
        link = { loai: 'ship', href: '/policies/shipping-policy', chu: 'View full Shipping Policy \u2192' };
      } else if (/money[\s-]*back[\s-]*guarantee/.test(ten)) {
        link = { loai: 'refund', href: '/policies/refund-policy', chu: 'View full Refund Policy \u2192' };
      }
      if (!link) return;
      if (ship.querySelector('[data-bb-link="' + link.loai + '"]')) return; /* đã có rồi */
      /* Tìm <ul> đầu tiên sau h */
      var n = h.nextElementSibling;
      while (n && n.tagName !== 'UL') n = n.nextElementSibling;
      if (!n || n.tagName !== 'UL') return;
      var p = document.createElement('p');
      p.className = 'bb-feat__d';
      p.setAttribute('data-bb-link', link.loai);
      p.innerHTML = '<a href="' + link.href + '">' + link.chu + '</a>';
      /* Chèn ngay sau <ul> này (cùng parent) */
      var parent = n.parentNode;
      if (n.nextSibling) {
        parent.insertBefore(p, n.nextSibling);
      } else {
        parent.appendChild(p);
      }
      daThem++;
    });
    return daThem;
  }

  /* Đổi số liệu SAI trong mô tả: "75%" → "70%" (chủ dự án chốt 17/10/2026). */
  function doiTiLeSai(goc) {
    var dem = 0;
    var walker = document.createTreeWalker(goc, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (/75\s*%/.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/75\s*%/g, '70%');
        dem++;
      }
    }
    return dem;
  }

  function chuanHoa(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function timQuyTacTieuDe(ten) {
    for (var i = 0; i < QUY_TAC.length; i++) {
      for (var j = 0; j < QUY_TAC[i].tieuDe.length; j++) {
        if (ten === QUY_TAC[i].tieuDe[j]) return QUY_TAC[i];
      }
    }
    return null;
  }
  function timQuyTacDoanManh(ten) {
    for (var i = 0; i < DOAN_MANH_QUY_TAC.length; i++) {
      if (ten.indexOf(DOAN_MANH_QUY_TAC[i].khoa) >= 0) return DOAN_MANH_QUY_TAC[i];
    }
    return null;
  }
  function mucTrong(el) {
    if (!el) return false;
    return el.children.length === 0 && (el.textContent || '').trim() === '';
  }
  function goNode(nut) {
    for (var i = 0; i < nut.length; i++) {
      var n = nut[i];
      if (n.parentNode) n.parentNode.removeChild(n);
    }
  }
  function tachTiLe(khoi) {
    for (var i = 0; i < khoi.nut.length; i++) {
      var n = khoi.nut[i];
      if (n.nodeType !== 1) continue;
      var txt = (n.textContent || '');
      if (/fabric\s*:/i.test(txt) && /bamboo/i.test(txt)) {
        var m = txt.match(/(\d{1,3})\s*%\s*bamboo/i);
        if (m) {
          /* 79: giữ nguyên CHUỖI thành phần THẬT của đôi này
           * (vd "45% bamboo fibre, 45% polyester · 10% spandex") để Mục 2 in đúng — không bịa.
           * Cắt ngay khi gặp "Size:/Height:/Compression:/Colour:/Style:" (cùng <li>). */
          var chuoi = txt.replace(/^[\s\S]*?fabric\s*:/i, '')
            .split(/\b(?:sizes?|height|compression|colou?r|style)\s*:/i)[0]
            .trim();
          return { phanTram: parseInt(m[1], 10), node: n, chuoi: chuoi };
        }
      }
    }
    return null;
  }
  function chenTiLe(dich, phanTram) {
    var p = document.createElement('p');
    p.className = 'bb-mota-ti-le';
    p.setAttribute('data-bb-ti-le', String(phanTram));
    p.innerHTML =
      '<strong>Sản phẩm này: ' + phanTram + '% bamboo fibre</strong>' +
      ' — đúng tỷ lệ ghi trong mô tả sản phẩm này. ' +
      'Xem bảng đầy đủ 3 dòng bên dưới để so sánh với dòng khác.';
    dich.insertBefore(p, dich.firstChild);
  }

  /* Highlight đúng DÒNG trong bảng 3 dòng tổng (Mục 2)
   * theo tỷ lệ vừa tách (data-bb-ti-le). Bỏ qua nếu không có.
   * LƯU Ý: Liquid KHÔNG tự decode &quot; trong default value của schema
   * ⇒ attribute value có thể là "45" (có dấu nháy). Tìm cả 2 dạng. */
  function highlightDongTiLe(phanTram) {
    if (!phanTram) return;
    /* Tìm dòng có data-bb-ti-le-dong khớp — bỏ qua dấu nháy vì Liquid KHÔNG decode &quot; */
    var ds = document.querySelectorAll('[data-bb-ti-le-dong]');
    var dong = null;
    for (var i = 0; i < ds.length; i++) {
      var val = (ds[i].getAttribute('data-bb-ti-le-dong') || '').replace(/['"]/g, '');
      if (val === String(phanTram)) { dong = ds[i]; break; }
    }
    if (!dong) return;
    var tr = dong.parentNode;
    if (tr && tr.tagName === 'TR') tr.setAttribute('data-bb-dong-dang-xem', '1');
  }

  function chay() {
    var goc = document.querySelector('[data-bb-mota]');
    if (!goc || goc.getAttribute('data-bb-da-chia') === '1') return;
    goc.setAttribute('data-bb-da-chia', '1');

    var con = [].slice.call(goc.childNodes);
    var khoi = [];
    con.forEach(function (n) {
      var laTieuDe = n.nodeType === 1 && /^H[1-6]$/.test(n.tagName);
      var laDoanManh = false;
      if (!laTieuDe && n.nodeType === 1 && (n.tagName === 'P' || n.tagName === 'DIV')) {
        var d = n.firstElementChild;
        laDoanManh = !!(d && d.tagName === 'STRONG');
      }
      if (laTieuDe || laDoanManh) {
        khoi.push({ nut: [n], ten: chuanHoa(n.textContent), laTieuDe: laTieuDe });
      } else if (khoi.length) {
        khoi[khoi.length - 1].nut.push(n);
      } else {
        khoi.push({ nut: [n], ten: '', laTieuDe: false, dau: true });
      }
    });

    var demChuyen = 0;
    var demAn = 0;
    var tiLeBat = null;
    var tiLeChuoi = '';   /* 79: chuỗi thành phần vải của đôi đang xem */
    khoi.forEach(function (k) {
      if (!k.ten) return;
      var qt = k.laTieuDe ? timQuyTacTieuDe(k.ten) : timQuyTacDoanManh(k.ten);
      if (!qt) return;
      var dich = document.querySelector('[data-bb-acc-than="' + qt.dich + '"]');
      if (!dich) return;

      if (qt.dich === 'fabric' && k.ten === 'details') {
        var tl = tachTiLe(k);
        if (tl && tl.phanTram) {
          /* 78c: BỎ dòng tiếng Việt "Sản phẩm này: …" (chủ dự án chốt) — chỉ giữ highlight ở bảng */
          if (tl.node && tl.node.parentNode) tl.node.parentNode.removeChild(tl.node);
          tiLeBat = tl.phanTram;
          tiLeChuoi = tl.chuoi || '';
        }
      }

      if (mucTrong(dich)) {
        var boc = document.createElement('div');
        boc.className = 'bb-mota-chuyen';
        for (var i = 1; i < k.nut.length; i++) boc.appendChild(k.nut[i]);
        dich.appendChild(boc);
        demChuyen++;
      } else {
        demAn++;
      }
      goNode(k.nut);
    });
    if (tiLeBat) highlightDongTiLe(tiLeBat);
    /* 79: MỤC 2 — dựng khối vải của ĐÚNG đôi đang xem (thay bảng 3 dòng) */
    var bbFab = null;
    try { bbFab = dungKhoiVai(tiLeBat, tiLeChuoi); } catch (e) { console.log('BB-FAB LOI:', e.message); }

    /* PHIÊN 78b: VIẾT MÔ TẢ THEO SP — chỉ sản phẩm đang thử (xem DS_THU ở đầu file).
     * Hàm này tự bỏ 2 gạch lặp, đổi 75→70, chèn đoạn theo dòng SP. */
    var bbMuc1 = null;
    try {
      if (dangApDung()) {
        bbMuc1 = vietMoTaTheoSp(goc, tiLeBat);
        /* 78b: ẩn Mục 3 (How to wear) khi đang thử — chủ dự án chốt bỏ */
        var m3 = document.querySelector('[data-bb-acc3]');
        if (m3) m3.parentNode.removeChild(m3);
        /* 78c: Care ngắn + 2 link policy đã nằm trong default của section (Liquid) */
      }
    } catch (e) {
      console.log('BB-MUC1 LOI:', e.message, e.stack);
    }

    window.bbChiaMota = {
      chuyen: demChuyen,
      an: demAn,
      tiLe: tiLeBat,
      vai: tiLeChuoi,
      fab: bbFab
    };
    window.bbMuc1 = bbMuc1;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }
  document.addEventListener('shopify:section:load', chay);
})();

